import React, { useRef, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { Select } from 'mailup-web-components'

import { searchState } from '../../recoil/state/search'

import {
  MESSAGE_LIST_TYPE_ALL,
  MESSAGE_LIST_TYPE_NOT_ARCHIVED,
  MESSAGE_LIST_TYPE_ARCHIVED,
  MESSAGE_LIST_TYPE_PUBLISHED,
  MESSAGE_LIST_TYPE_NOTIFICATION
} from 'Constants'

export const InputType = ({ onChange }) => {
  const intl = useIntl()
  const search = useRecoilValue(searchState)
  const setSearchState = useSetRecoilState(searchState)

  const { type } = search

  const { current: options } = useRef([
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.AllSearchOptions'
      }),
      value: MESSAGE_LIST_TYPE_ALL
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.NotArchivedSearchOptions'
      }),
      value: MESSAGE_LIST_TYPE_NOT_ARCHIVED
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.ArchivedSearchOptions'
      }),
      value: MESSAGE_LIST_TYPE_ARCHIVED
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.PublishedSearchOptions'
      }),
      value: MESSAGE_LIST_TYPE_PUBLISHED
    },
    {
      label: intl.formatMessage({ id: 'Load.EmailMessageList.Notification' }),
      value: MESSAGE_LIST_TYPE_NOTIFICATION
    }
  ])

  const handleChange = value => {
    setSearchState(prev => ({
      ...prev,
      type: value
    }))
  }

  useEffect(() => {
    type && onChange(type)
  }, [type])

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleChange}
      value={type}
    />
  )
}
